  <!-- <form [formGroup]="UserlogForm"> -->
    <div class="grid">
      <div class="col-12 md:col-3 lg:col-3 sm:col-3">
        <label class="filter" for="logtype" style="color: #e20b50;">Log Type</label>
        <label for="pagemodal" class="required-label">
          <!-- <span style="color: rgb(60, 137, 246);font-size:9px !important;">Log Type is manadatory</span> -->
          <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span></label>
        <p-dropdown [filter]="true" [pTooltip]="getlogtypeTooltip()" [options]="logtypeList" [resetFilterOnHide]="true"
          [(ngModel)]="filterinput.logtype" placeholder="Select" optionLabel="labelname" optionValue="value"
          styleClass="fixed-width-dropdown-filter" id="logtype" name="logtype" (onChange)="onFilterSelect()"
          inputId="logtype"></p-dropdown>
                      <span *ngIf="logtypeerrorDIsplay" style="color: red;">Log Type is required</span>  
        <!-- <span style="color:red" class="errormessage"
          *ngIf="UserlogForm.get('logtype').invalid && (UserlogForm.get('logtype').dirty || UserlogForm.get('logtype').touched)">
          {{getErrorMessage(UserlogForm ,validation_message,'logtype')}}
        </span> -->
      </div>
      <div class="col-12 md:col-3 lg:col-3 sm:col-3">
        <label class="filter" for="user" style="color: #e20b50;">User</label>
        <p-dropdown [filter]="true" [showClear]="true" [pTooltip]="getuserTooltip()" [options]="userList" id="user"
          name="user" [(ngModel)]="filterinput.user" placeholder="Select" optionLabel="labelname" inputId="user" [resetFilterOnHide]="true"
          (onChange)="onFilterSelect()" optionValue="value" styleClass="fixed-width-dropdown-filter">
        </p-dropdown>
      </div>
      <div class="col-12 md:col-3 lg:col-3 sm:col-3">
        <label for="location" class="filter" style="color: #e20b50;">Location</label>
        <p-dropdown [filter]="true" [showClear]="true" [pTooltip]="getlocationTooltip()" [options]="locationList" [resetFilterOnHide]="true"
          id="location" name="location" [(ngModel)]="filterinput.location" placeholder="Select" optionLabel="labelname"
          inputId="location" (onChange)="onFilterSelect()" optionValue="value"
          styleClass="fixed-width-dropdown-filter">
        </p-dropdown>
      </div>
      <div class="col-12 md:col-3 lg:col-3 sm:col-3">
        <label class="filter" for="department" style="color: #e20b50;">Department</label>
        <p-dropdown [filter]="true" [showClear]="true" [pTooltip]="getdepartmentTooltip()" [options]="departmentList"
          id="department" name="department" [(ngModel)]="filterinput.department" placeholder="Select" [resetFilterOnHide]="true"
          optionLabel="labelname" inputId="department" (onChange)="onFilterSelect()" optionValue="value"
          styleClass="fixed-width-dropdown-filter">
        </p-dropdown>
      </div>
      <div class="col-12 md:col-2 lg:col-2 sm:col-2">
        <label class="filter" for="fromdate" style="color: #e20b50;">From Date</label>
        <p-calendar [showIcon]="true" [pTooltip]="getdatetooltip('from')"  [maxDate]="today"  placeholder="Choose Date" [(ngModel)]="filterinput.from_date"
          dateFormat="dd-M-yy" (ngModelChange)="updateFilters()" name="from_date" [clearButtonStyleClass]="'hideClearButton'"
          inputId="from_date" [readonlyInput]="true" [showButtonBar]="true" appendTo="body" [showOtherMonths]="true" [selectOtherMonths]="true"
          [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
                    <div class="error-space" style="margin-top: 5px;">
                  <span *ngIf="fromdateerrorDisplay" style="color: red;">From date is required</span></div>
      </div>
      <div class="col-12 md:col-2 lg:col-2 sm:col-2">
        <label class="filter" for="todate" style="color: #e20b50;">To Date</label>
        <p-calendar [pTooltip]="getdatetooltip('to')" [showIcon]="true" [maxDate]="today" placeholder="Choose Date" [(ngModel)]="filterinput.to_date"
          dateFormat="dd-M-yy" (ngModelChange)="updateFilters()" inputId="to_date" [clearButtonStyleClass]="'hideClearButton'"
          [readonlyInput]="true" [showButtonBar]="true" appendTo="body" [showOtherMonths]="true" name="to_date" [selectOtherMonths]="true"
          [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
                    <div class="error-space" style="margin-top: 5px;">
                  <span *ngIf="errorDIsplay" style="color: red;">To date should be greater than from date</span>
            <span *ngIf="todateerrorDIsplay" style="color: red;">To date is required</span>    </div></div>
      <p-button [style.marginTop.px]="5" [style.marginLeft.px]="0" styleClass="refreshbtn reset-btn" severity="success"
        pTooltip="Reset" (click)="refreshFilters()">
        <i class="fa fa-refresh" aria-hidden="true"></i>
      </p-button>
    </div>
  <!-- </form> -->